import { StandardEvents } from '@shopify/events';

export function activeFieldCount(value,maximum){
  const number=Number(value);
  return Number.isInteger(number)&&number>=1&&number<=maximum?number:0;
}
export function validPhoto(file){
  return Boolean(file&&['image/jpeg','image/png','image/webp'].includes(file.type)&&file.size>0&&file.size<=20*1024*1024);
}

export class Personalization extends HTMLElement {
  #controller; #objectURL; #generation=0; #pending=false; #variants={};
  connectedCallback(){
    this.#controller?.abort();this.#controller=new AbortController();
    const {signal}=this.#controller;
    this.#variants=JSON.parse(this.querySelector('[data-personal-variants]')?.textContent||'{}');
    this.addEventListener('change',()=>this.sync(),{signal});
    this.addEventListener('input',event=>{
      event.target.setCustomValidity?.('');this.setError('');
      if(event.target.matches('[data-optional-engraving]'))this.syncFont();
    },{signal});
    this.querySelector('[data-remove-photo]')?.addEventListener('click',()=>{
      this.querySelector('input[type=file]').value='';this.updatePhoto();
    },{signal});
    this.closest('.shopify-section')?.addEventListener(StandardEvents.productSelect,event=>{
      const picker=event.target.closest('variant-picker');
      if(!picker||picker.dataset.productId!==this.dataset.productId||event.target.closest('product-card'))return;
      const generation=++this.#generation;this.#pending=true;
      event.promise.then(({detail})=>{
        if(generation!==this.#generation||!this.isConnected)return;
        if(detail?.newProduct&&String(detail.newProduct.id)!==this.dataset.productId){
          const next=detail.html?.querySelector('sf-personalization');
          if(next)this.replaceWith(next.cloneNode(true));else this.remove();
          return;
        }
        this.sync(detail?.resource?.id);
      }).catch(()=>{}).finally(()=>{
        if(generation===this.#generation){this.#pending=false;this.setError('');}
      });
    },{signal});
    this.sync();
  }
  disconnectedCallback(){this.#controller?.abort();if(this.#objectURL)URL.revokeObjectURL(this.#objectURL);}
  sync(variantId){
    const fields=[...this.querySelectorAll('[data-personal-field]')];
    const choice=this.querySelector('[data-personal-count]');
    let count=fields.length;
    if(choice)count=activeFieldCount(choice.value,fields.length);
    else if(Number(this.dataset.countPosition)>=0){
      const id=variantId??this.closest('form')?.querySelector('[name=id]')?.value;
      count=activeFieldCount(this.#variants[String(id)],fields.length);
    }
    fields.forEach((field,index)=>{
      const input=field.querySelector('input');const active=index<count;
      field.hidden=!active;input.disabled=!active;input.required=active&&input.dataset.required==='true';
    });
    this.syncFont();this.updatePhoto();
  }
  syncFont(){
    const font=this.querySelector('[data-personal-font]');
    if(font)font.disabled=!this.querySelector('[data-optional-engraving]').value.trim();
  }
  updatePhoto(){
    const input=this.querySelector('input[type=file]');if(!input)return;
    const preview=this.querySelector('.sf-personal__preview');
    const file=input.files?.[0];input.setCustomValidity(file&&!validPhoto(file)?this.dataset.fileError:'');
    if(this.#objectURL)URL.revokeObjectURL(this.#objectURL);this.#objectURL=undefined;
    preview.hidden=!file||!validPhoto(file);
    if(!preview.hidden){
      this.#objectURL=URL.createObjectURL(file);preview.querySelector('img').src=this.#objectURL;
      preview.querySelector('[data-photo-name]').textContent=file.name;
    }
  }
  setError(message){const node=this.querySelector('.sf-personal__error');node.textContent=message;node.hidden=!message;}
  showPending(){this.setError(this.dataset.pendingMessage);}
  validate(){
    if(this.#pending){this.showPending();return false;}
    this.sync();
    for(const input of this.querySelectorAll('[data-personal-text]:not(:disabled)')){
      input.value=input.value.trim();input.setCustomValidity(input.required&&!input.value?this.dataset.emptyError:'');
    }
    const valid=this.closest('form').reportValidity();
    if(!valid)this.querySelector(':invalid')?.focus();
    return valid;
  }
}
if(!customElements.get('sf-personalization'))customElements.define('sf-personalization',Personalization);
